<section class="footer" id="footer">
  <div class="container">
    <div class="row g-4">
      <div class="col-12 col-lg-4">
        <h2 class="footer-heading">{{ 'footer_navigation.org_name' | translate }}</h2>
        <p class="footer-desc">{{ 'footer_navigation.org_desc' | translate }}</p>
        <!-- TODO: add the real PUPA Facebook page URL -->
        <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" rel="noopener noreferrer" class="logo" aria-label="PUPA on Facebook">
          <!-- TODO: replace with actual social-facebook.svg -->
          <img src="./assets/images/png/logo.png" alt="PUPA" loading="lazy" />
        </a>
      </div>

      <div class="col-12 col-lg-2"></div>
      <div class="col-12 col-lg-3">
        <h2 class="footer-heading">{{ 'footer_navigation.title_1' | translate }}</h2>
        <ul class="footer-links w-100 d-flex flex-row flex-lg-column align-items-center align-items-lg-start justify-content-center justify-content-lg-start flex-wrap gap-3">
          @for (item of quickLinks; track item) {
            <li>
              @if (item.isPage) {
                <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage + '/' + item.routeName : item.routeName }}"
                  title="{{ item.routeName }}">{{ item.title | translate }}</a>
              } @else {
                <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}"
                  title="{{ item.routeName }}">{{ item.title | translate }}</a>
              }
            </li>
          }
        </ul>
      </div>

      <div class="col-12 col-lg-3">
        <h2 class="footer-heading">{{ 'footer_navigation.title_2' | translate }}</h2>
        <div class="d-flex flex-row flex-lg-column align-items-center justify-content-between"></div>
        <p class="footer-contact-item">
          <strong>{{ 'footer_navigation.address_label' | translate }}</strong><br />
          {{ 'footer_navigation.address_value' | translate }}
        </p>
        <p class="footer-contact-item">
          <strong>{{ 'footer_navigation.phone_label' | translate }}</strong><br />
          {{ 'footer_navigation.phone_value' | translate }}
        </p>
        <p class="footer-contact-item">
          <strong>{{ 'footer_navigation.email_label' | translate }}</strong><br />
          <a href="mailto:pupaamargram@gmail.com" class="text-tertiary">{{ 'footer_navigation.email_value' | translate }}</a>
        </p>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container">
      <p class="mb-0">{{ 'footer_navigation.copyright' | translate }}</p>
    </div>
  </div>
</section>
